import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-preview-view",
  "use": "icon-preview-view-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-preview-view\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.41494 3.17578H13.5914V9.41108H2.41494V3.17578ZM1.41494 2.17578H2.41494H13.5914H14.5914V3.17578V9.41108V10.4111H13.5914H2.41494H1.41494V9.41108V3.17578V2.17578ZM15.0032 13.5365H1.00317V14.5365H15.0032V13.5365Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol